<template>
  <page-wrapper :title="title">
    <div class="create-introduction-container container">
      <FeatureIntroductionEditor
        :form="featureIntroductionPresenter"
        @addPage="handleOnAddPage"
        @deletePage="handleOnDeleteFeatureIntroductionPage"
        @textInputChange="handleOnTextInputChange"
        @imageChanged="handleOnImageChange"
        @platformFieldChange="handlePlatformFieldChange"
      />
    </div>
  </page-wrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper"

import { FeatureIntroductionPresenter } from "@/presenters/featureIntroduction/FeatureIntroductionPresenter"
import FeatureIntroductionEditor from "../components/FeatureIntroductionEditor"

export default {
  components: {
    PageWrapper,
    FeatureIntroductionEditor,
  },
  data() {
    const title = "สร้าง Feature Introduction ใหม่"
    const form = {
      platform: {
        iOS: {
          isSelected: false,
          version: "",
        },
        android: {
          isSelected: false,
          version: "",
        },
      },
      pageList: [
        {
          title: "",
          message: "",
          imageFile: null,
        },
      ],
    }

    return {
      title,
      form,
    }
  },
  computed: {
    featureIntroductionPresenter() {
      return new FeatureIntroductionPresenter(this.form)
    },
  },
  methods: {
    handleOnAddPage() {
      this.form.pageList.push({
        title: "",
        message: "",
        imageFile: null,
      })
    },
    handleOnTextInputChange(valueChanged) {
      const { formName, pageIndex, newValue, oldValue } = valueChanged
      switch (formName) {
        case "title":
          this.$set(this.form.pageList, pageIndex, {
            ...oldValue,
            title: newValue,
          })
          break
        case "message":
          this.$set(this.form.pageList, pageIndex, {
            ...oldValue,
            message: newValue,
          })
          break
        default:
          // eslint-disable-next-line no-console
          console.error("Invalid Feature Introduction Form")
      }
    },
    handleOnImageChange(imageChanged) {
      const { pageIndex, imageFile, oldValue } = imageChanged
      this.$set(this.form.pageList, pageIndex, {
        ...oldValue,
        imageFile,
      })
    },
    handlePlatformFieldChange({ platform, field, value }) {
      this.$set(this.form.platform[platform], field, value)
    },
    handleOnDeleteFeatureIntroductionPage(pageIndexToDelete) {
      const newPageList = this.form.pageList.filter(
        (page, pageIndex) => pageIndex !== pageIndexToDelete,
      )
      this.$set(this.form, "pageList", newPageList)
    },
  },
}
</script>

<style lang="scss" scoped>
.create-introduction-container {
  height: 100%;
}
</style>
